export default "__VITE_ASSET__Cpytiy32__"